module.exports = __webpack_public_path__ + "img/plan-04-m.1bc50af7.png";